"use client";

import React from "react";
import { cn } from "utils/utils";
import { Infinity as InfinityIcon } from "lucide-react";
import { useCardGridItemContext } from "./CardGridItemContext";

interface CardGridItemAnyPrintingBadgeProps {
  className?: string;
  iconSize?: number;
}

export function CardGridItemAnyPrintingBadge({
  className,
  iconSize = 32,
}: CardGridItemAnyPrintingBadgeProps) {
  const { item } = useCardGridItemContext();

  if (!item.anyPrinting) {
    return null;
  }

  return (
    <div
      className={cn(
        "lg:tooltip lg:tooltip-secondary flex items-center",
        className
      )}
      data-tip="Any set / printing"
    >
      <span className="text-secondary inline-flex items-center gap-1">
        <span className="hidden text-xs md:inline-flex">Any set</span>
        <InfinityIcon size={iconSize} />
      </span>
    </div>
  );
}
